<script>

import { API_COMPANY } from '../../common/api'
import BaseList from '../BaseList'
import MyPagination from '../../components/MyPagination'
import CompanyAdd from './CompanyAdd'
import CompanyUpdate from './CompanyUpdate'

export default {
  name: 'CompanyList',
  extends: BaseList,
  data () {
    return {
      searchForm: {
        name: ''
      },
    }
  },
  created () {
    // 获取公司列表
    this.getDataList();
    this.tableHeight = window.innerHeight - 150;
  },
  methods: {
    // 公司列表
    getDataList () {
      this.loading = true;
      let params = {
        page_no: this.currentPage,
        page_num: this.pageSize,
        name: this.searchForm.name
      };
      this.$http.GET(API_COMPANY, params,
      res => {
        this.tableData = res.result.list;
        this.totalCount = res.result.total;
        this.loading = false;
      }, err => {
        this.loading = false;
        this.$message.error(err.msg);
      })
    },
  },
  components: {
    CompanyAdd,
    CompanyUpdate,
    MyPagination
  }
}
</script>

<template>
  <div class="main">
    <div class="search_section">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item>
          <el-input v-model="searchForm.name" placeholder="公司名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchData">搜索</el-button>
        </el-form-item>

        <el-button type="primary" @click="addDialogVisible = true" size="small" class="add">新增</el-button>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      :height="tableHeight"
      size="small"
      border
      style="padding: 5px;">
      <el-table-column label="公司名称" prop="name" min-width="2"></el-table-column>
      <el-table-column label="电话" prop="phone" min-width="1"></el-table-column>
      <el-table-column label="厂长" prop="admin_name" min-width="1"></el-table-column>
      <el-table-column label="手机号" prop="admin_mobile" min-width="1"></el-table-column>
      <el-table-column label="水费" prop="price" min-width="1"></el-table-column>
      <el-table-column label="税率" prop="tax" min-width="1"></el-table-column>
      <el-table-column label="用户前缀" prop="number_pre" min-width="1"></el-table-column>
      <el-table-column label="用户表" prop="user_table" min-width="1"></el-table-column>
      <el-table-column label="开始日期" prop="start_date" min-width="1"></el-table-column>
      <el-table-column label="结束日期" prop="end_date" min-width="1"></el-table-column>
      <!--<el-table-column label="状态" prop="status" min-width="1">-->
        <!--<template slot-scope="scope">-->
          <!--<el-switch-->
            <!--v-model="scope.row.status"-->
            <!--active-value="OPEN"-->
            <!--inactive-value="CLOSE"-->
            <!--active-color="#13ce66"-->
            <!--inactive-color="#ff4949"-->
            <!--@change="(val) => changeStatus(scope.row.id, val)">-->
          <!--</el-switch>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column label="操作" align="center" min-width="1">
        <template slot-scope="{row}">
          <el-tooltip class="operate_item" effect="dark" content="修改" placement="top">
            <i class="iconfont icon-bianji operate_font" @click="showUpdate(row.id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <MyPagination :totalCount="totalCount" :currentPage="currentPage" @handleSizeChange="handleSizeChange"
                  @handleCurrentChange="handleCurrentChange"></MyPagination>

    <el-dialog
      title="新增公司"
      v-if="addDialogVisible"
      :visible.sync="addDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <CompanyAdd @addCompanySuccess="addSuccess"></CompanyAdd>
    </el-dialog>

    <el-dialog
      title="修改公司"
      v-if="updateDialogVisible"
      :visible.sync="updateDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <CompanyUpdate :company_id="this.operateId" @updateCompanySuccess="updateSuccess"></CompanyUpdate>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/company/CompanyList.vue